<template>
  <div>
    <div
      v-show="!detailShow"
      style="display:flex;flex-direction: row;margin-bottom:20px;justify-content: space-between;;"
    >
      <div>
      <a-button v-if="btnPriviliges.btn_add == '1'"
        type="primary"
        @click="()=>{SchooCUModalVisible=true;updateSchoolModal=null}"
        icon="file-add"
      >新增驾校</a-button>
      </div>
      <div style="display:flex;flex-direction: row;justify-content: flex-end">
        <!-- <a-input
          style="width:20vw;"
          addonBefore="驾校名称"
          placeholder="请输入驾校名称"
          v-model="drivschName"
        /> -->

        <div>
          <span>驾校名称：</span>
          <!-- <a-auto-complete
            showSearch
            placeholder="请输入驾校"
            style="width:165px"
            @search="drivschSearch"
            v-model="drivschName"
          >
            <template slot="dataSource">
              <a-select-option
                v-for="(item,index) in drivschList"
                :value="item.drivschname"
                :key="index"
              >{{item.drivschname}}</a-select-option>
            </template>
          </a-auto-complete> -->
          <a-select
          allowClear
          showSearch
          placeholder="请选择驾校"
          :filterOption="filterOption"
          style="width:165px;"
          v-model="drivschName"
        >
          <a-select-option
            :value="item.drivschname"
            v-for="(item,idx) in drivschList"
            :key="idx"
          >{{item.drivschname}}</a-select-option>
        </a-select>
        </div>

        <a-button
          type="primary"
          style="margin-left:16px;"
          icon="search"
          @click="()=>{this.pagination.current = 1;fetch()}"
        >查询</a-button>
      </div>
    </div>
    <div v-show="!detailShow">
      <j-table
        :tableColumns="columns"
        :rowKey="record => record.drivschid"
        :tableData="schoolList"
        :loading="loading"
        :tablePagination="pagination"
        v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
        v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }"
      >
        <template v-slot="record">
          <div style="display:flex;flex-direction:row;justify-content:space-around;align-items:center">
            <a v-if="btnPriviliges.btn_details == '1'" @click="showDetails(record)">详情</a>
            <a v-if="btnPriviliges.btn_update == '1'" @click="()=>{SchooCUModalVisible=true;updateSchoolModal=record;}">编辑</a>
            <a v-if="btnPriviliges.btn_user == '1'" @click="()=>{userManageVisible = true;orgId=record['drivschid']}">用户管理</a>
            <a v-if="btnPriviliges.btn_department == '1'" @click="()=>{departmentManageVisible = true;orgId=record['drivschid']}">部门管理</a>
            <a v-if="btnPriviliges.btn_role == '1'" @click="()=>{roleManageVisible = true;orgId=record['drivschid']}">角色管理</a>
          </div>
        </template>
      </j-table>
    </div>
    <d-school
      v-if="detailShow"
      :parameters="params"
      v-on:onClose="()=>{detailShow = false;}"
    >
    </d-school>
    <UserManage 
      v-if="userManageVisible"
      v-on:close="userManageVisible = false"
      :orgId="orgId"
      systemId="4"/>
    <DepartmentManage 
      v-if="departmentManageVisible"
      v-on:close="departmentManageVisible = false"
      :orgId="orgId"
      :flag="1"/>
    <RoleManage 
      v-if="roleManageVisible"
      v-on:close="roleManageVisible = false"
      :orgId="orgId"
      :flag="1"/>
    <SchooCUModal 
      v-if="SchooCUModalVisible"
      :updateSchoolModal="updateSchoolModal"
       v-on:close="(refresh)=>{SchooCUModalVisible=false;if(refresh){fetch()}}"/>
  </div>
</template>
<script>
import mixins from "../../mixins";
import JTable from "../../components/JTable";
import DSchool from "../../components/SchoolDetails";
import UserManage from "../../components/UserManage";
import DepartmentManage from "../../components/DepartmentManage"
import RoleManage from "../../components/RoleManage";
import SchooCUModal from "../../components/SchoolCUModal"

const columns = [
  {
    title: "驾校简称",
    dataIndex: "drivschshtname",
    key: "drivschshtname",
    fixed: "left",
    align: "center"
  },
  // {
  //   title: "驾校ID",
  //   dataIndex: "drivschid",
  //   key: "drivschid",
  //   fixed: "left",
  //   align: "center"
  // },
  {
    title: "驾校名称",
    dataIndex: "drivschname",
    key: "drivschname",
    align: "center",
    fixed: "left",
  },
  // {
  //   title: "驾协ID",
  //   dataIndex: "drivasstid",
  //   key: "drivasstid",
  //   align: "center"
  // },
  // {
  //   title: "创建时间",
  //   dataIndex: "credatetime",
  //   key: "credatetime",
  //   align: "center"
  // },
  // { title: "创建人ID", dataIndex: "inputop", key: "inputop", align: "center" },
  { title: "城市代码", dataIndex: "city", key: "city", align: "center" },
  {
    title: "驾校地址",
    dataIndex: "drivschadress",
    key: "drivschadress",
    align: "center"
  },
  { title: "省代码", dataIndex: "provice", key: "provice", align: "center" },
  { title: "区县代码", dataIndex: "county", key: "county", align: "center" },
  {
    title: "联系人名称",
    dataIndex: "contactsname",
    key: "contactsname",
    align: "center"
  },
  {
    title: "联系人邮箱",
    dataIndex: "contactsemail",
    key: "contactsemail",
    align: "center",
    width:200

  },
  {
    title: "联系人手机",
    dataIndex: "contactsmobile",
    key: "contactsmobile",
    align: "center"
  },
  {
    title: "联系人电话",
    dataIndex: "contactsphone",
    key: "contactsphone",
    align: "center",
    width:200

  },
  {
    title: "财务名称",
    dataIndex: "fincontactsname",
    key: "fincontactsname",
    align: "center"
  },
  {
    title: "财务手机",
    dataIndex: "finacontactsmobile",
    key: "finacontactsmobile",
    align: "center"
  },
  {
    title: "财务邮箱",
    dataIndex: "fincontactsemail",
    key: "fincontactsemail",
    align: "center",
    width:200
  },
  {
    title: "财务电话",
    dataIndex: "fincontactsphone",
    key: "fincontactsphone",
    align: "center",
    width:200
  },
  // {
  //   title: "修改时间",
  //   dataIndex: "moddatetime",
  //   key: "moddatetime",
  //   align: "center"
  // },
  // { title: "修改人", dataIndex: "modopr", key: "modopr", align: "center" },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center",
    fixed: "right",
    width:170,
  }
];
export default {
  name: 'Schools',
  mixins: [mixins],
  components: {
    JTable,
    DSchool,
    UserManage,
    DepartmentManage,
    RoleManage,
    SchooCUModal,
  },
  created() {
    const that = this;
    this.$btnAccess.getBtnByModule('/schools',(data) => {
      this.$log.success('按钮权限-----'+JSON.stringify(data));
      that.btnPriviliges = data;
      if(that.btnPriviliges['btn_details'] != '1' && that.btnPriviliges['btn_user'] != '1' && that.btnPriviliges['btn_department'] != '1'&& that.btnPriviliges['btn_role'] != '1'){
        that.columns.pop();
      }
    });
    this.fetch();
    this.drivschSearch();
  },
  data() {
    return {
      btnPriviliges:{},
      schoolList: [],
      drivschList: [],
      params: {},
      columns,
      loading: false,
      drivschName: "",
      pagination: {
        pageSize: 10,
        pageSizeOptions: ["1", "10", "20", "50", "100"],
        current: 1,
        total: 0
      },
      orderby: "drivschid asc",
      operationWidth: 180,
      detailShow: false,
      userManageVisible:false,
      roleManageVisible:false,
      orgId: '',
      SchooCUModalVisible:false,
      updateSchoolModal:null,
      departmentManageVisible:false,
    };
  },
  computed: {},
  methods: {
    showDetails(record) {
      this.detailShow = true;
      this.params.drivschid = record.drivschid;
      this.params.drivasstid = record.drivasstid;
    },
    fetch() {
      const that = this;
      that.schoolList = [];
      that.loading = true;
      const reqData = {
        currpage: that.pagination.current + "",
        drivasstid:that.$cache.session.get(that.$marco.constants.KEY_ORG_ID),
        orderby: that.orderby,
        recnumperpage: that.pagination.pageSize + ""
      };
      if (that.drivschName) {
        reqData["drivschname"] = that.drivschName;
      }
      this.$http.post(
        this.$marco.api.drivschPagingList,
        reqData,
        data => {
          that.loading = false;
          this.$log.success(
            "请求成功返回正确数据------" + JSON.stringify(data)
          );
          that.schoolList = that.schoolList.concat(data.pagelist);
          that.pagination["total"] = data.recnum;
        },
        errorDesc => {
          that.loading = false;
          this.$log.normal(
            "请求成功返回失败--------" + JSON.stringify(errorDesc)
          );
        },
        error => {
          that.loading = false;
          this.$log.error("请求失败---------" + JSON.stringify(error));
        }
      );
    },
    drivschSearch(value) {
      const that = this;
      that.drivschList = [];
      that.$http.post(
        that.$marco.api.schoolId,
        { 
          drivasstid: that.$cache.session.get(that.$marco.constants.KEY_ORG_ID),
        },
        data => {
          this.$log.success("驾校模糊查询" + JSON.stringify(data));
          that.drivschList = [];
          that.drivschList = data;
        },
        errorDesc => {
          this.$log.normal("驾校模糊查询" + JSON.stringify(errorDesc));
        },
        error => {
          this.$log.error("驾校模糊查询" + JSON.stringify(error));
        },
        that
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  }
};
</script>
<style scoped>
.ant-pagination {
  margin: 24px auto;
}
</style>